import { useEffect, useState } from "react";
import { assetUrl } from "../utils/api";
import { formatCityLabel } from "../utils/resolveRegion";
import {
  buildProfileGalleryUrls,
  ClickableImage,
  useImageLightbox,
} from "../components/ImageLightbox";

export default function PreviewPage() {
  const currentUserId = localStorage.getItem("user_id");
  const [user, setUser] = useState(null);

  const galleryUrls = user
    ? buildProfileGalleryUrls(user.avatar, user.photos).map((url) => assetUrl(url))
    : [];
  const { openAt, lightbox } = useImageLightbox(galleryUrls);
  const photoStartIndex = user?.avatar ? 1 : 0;

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const res = await fetch(`/api/profile/${currentUserId}`);
        const data = await res.json();

        if (res.ok) {
          setUser(data);
        }
      } catch (err) {
        console.error("加载主页预览失败:", err);
      }
    };

    if (currentUserId) {
      loadProfile();
    }
  }, [currentUserId]);

  if (!user) {
    return <div className="text-center text-gray-400 py-10">加载中...</div>;
  }

  const avatarSrc = user.avatar
    ? assetUrl(user.avatar)
    : "https://via.placeholder.com/120";

  return (
    <div className="space-y-6">
      <div className="text-center">
        <ClickableImage
          src={avatarSrc}
          alt={user.name}
          className="w-28 h-28 rounded-full object-cover mx-auto mb-4"
          onOpen={() => openAt(0)}
          disabled={!galleryUrls.length}
        />
        <h2 className="text-2xl font-bold">{user.name}</h2>
        <p className="text-gray-500">{user.age || "?"}岁 · {formatCityLabel(user.province, user.city, user.district, "未填写城市")}</p>
      </div>




{user.photos?.length > 0 && (
  <div>
    <h3 className="font-semibold mb-3">我的相册</h3>
    <div className="grid grid-cols-3 gap-3">
      {user.photos.map((photo, index) => {
        // photo 可以是字符串，也可以是对象
        const src = assetUrl(
          typeof photo === "string"
            ? photo
            : photo?.image_url || ""
        );

        if (!src) return null; // 防止空值渲染

        return (
          <ClickableImage
            key={photo.id || index}
            src={src}
            alt={`相册${index + 1}`}
            className="w-full h-28 object-cover rounded-lg"
            onOpen={() => openAt(photoStartIndex + index)}
          />
        );
      })}
    </div>
  </div>
)}

      <div className="grid grid-cols-2 gap-4 text-sm">
        <p>性别：{user.gender || "未填写"}</p>
        <p>学历：{user.education || "未填写"}</p>
        <p>职业：{user.job || "未填写"}</p>
        <p>月收入：{user.monthly_income || "未填写"}</p>
        <p>身高：{user.height ? `${user.height}cm` : "未填写"}</p>
        <p>体重：{user.weight ? `${user.weight}kg` : "未填写"}</p>
           <p>宗教信仰：{user.religion ? `${user.religion}` : "未填写"}</p>
      </div>

      <div>
        <h3 className="font-semibold mb-2">自我介绍</h3>
        <p className="text-gray-600">{user.bio || "未填写"}</p>
      </div>

      <div>
        <h3 className="font-semibold mb-2">兴趣爱好</h3>
        <p className="text-gray-600">{user.hobbies || "未填写"}</p>
      </div>

      <div>
        <h3 className="font-semibold mb-2">择偶要求</h3>
        <p className="text-gray-600">{user.partner_requirement || "未填写"}</p>
      </div>
      {lightbox}
    </div>
  );
}
